module.exports = __webpack_public_path__ + "img/car.ce852f6f.jpg";